import { CognitoUserPool } from 'amazon-cognito-identity-js'

const poolData = {
    UserPoolId: "eu-west-3_DP2ZMYFVO",
    ClientId: "53790sslll2d5bgd85bhd33u3n"
}

export default new CognitoUserPool(poolData)